/**
 * @fileoverview Provide compact value/status signifiers across application workspaces. Callers choose the value and semantic severity; this presentation component does not derive business status. `AppTag.js` provides the related text-label treatment.
 */

import React from 'react'

const severityColors = {
    success: { bg: '#16a34a', color: '#ffffff' },
    danger: { bg: '#dc2626', color: '#ffffff' },
    warning: { bg: '#eab308', color: '#ffffff' },
    info: { bg: '#0ea5e9', color: '#ffffff' },
    secondary: { bg: 'var(--surface-400, #94a3b8)', color: '#ffffff' }
}



function AppBadge({ value, severity = 'info', size, className, style: extraStyle }) {
    const colors = severityColors[severity] || severityColors.info
    const isLarge = size === 'large'
    const style = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: isLarge ? '0.35rem 0.75rem' : '0.15rem 0.5rem',
        fontSize: isLarge ? '0.875rem' : '0.7rem',
        fontWeight: 700,
        borderRadius: '999px',
        backgroundColor: colors.bg,
        color: colors.color,
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
        ...extraStyle
    }

    return (
        <span className={className || ''} style={style}>
            {value}
        </span>
    )
}

export default AppBadge

export { AppBadge as Badge };
